import PuxAlert from "../../../../../global/components/PuxAlert/PuxAlert.vue";
import PuxButton from "../../../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../../../global/components/PuxTranslate/PuxTranslate.vue";

// @vue/component
export default {
  name: "VertragWizardEinreichenErrors",
  components: {
    PuxAlert,
    PuxButton,
    PuxTranslate,
  },
  props: {
    validationErrors: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isVisible() {
      return this.validationErrors.length > 0;
    },
  },
};
